import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function list(params) {
	return client.get('/tunnel/api/public/stockist/data', {
		params
	});
}

function province() {
	return client.get('/tunnel/api/public/general/provinceStockist', {});
}

function city(params) {
	return client.get('/tunnel/api/public/general/city', {
		params
	});
}

function subdistrict(params) {
	return client.get('/tunnel/api/public/general/subdistrict', {
		params
	});
}

function listByProduct(params) {
	return client.get('/tunnel/api/public/stockist/data-by-product', {
		params
	});
}

function detail(code) {
	return client.get('/tunnel/api/public/stockist/detail', {
		params: {
			code: code
		}
	});
}

function review(code) {
	return client.get('/tunnel/api/public/stockist/review', {
		params: {
			code: code
		}
	});
}
export default {
	list,
	listByProduct,
	detail,
	review,
	province,
	city,
	subdistrict,
};